export class categoryFood {
  id: number;
  name: string;
  sizes: Array<Object>;
}
